import React from 'react';
import { AppHeader } from '@/components/AppHeader';

export function PageHeaderWrapper(props) {
  return <AppHeader {...props} />;
}